import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AuthData } from '../../../context/auth';
import { ErrorData } from '../../../context/ErrorProvider';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../../context/premiumReport';
import { PRIMARY_BUTTON_STYLE } from '../../../data/constants';
import { errorToast, successToast } from '../../Toast';

interface Props {
	authData: AuthData;
	errorData: ErrorData;
	premiumReportData: PremiumReportData;
}

const ReplaceReportModal = ({ premiumReportData, errorData }: Props) => {
	const { getValues, formState, reset } = useFormContext();
	const { dirtyFields } = formState;
	const navigate = useNavigate();
	const [open, setOpen] = React.useState(false);
	const [submitting, setSubmitting] = React.useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const replaceReport = async () => {
		setSubmitting(true);
		handleClose();
		premiumReportData.setLoading(true);
		try {
			const replacedPremiumReport = await premiumReportData.replaceReport(
				getValues(),
				dirtyFields,
				reset,
				{},
			);
			navigate(
				`/policy/${replacedPremiumReport.policyLocator}/premiumReports/${replacedPremiumReport.locator}`,
			);
			successToast('Successfully replaced report');
		} catch (e) {
			errorToast('Failed to replace premium report');
		} finally {
			setSubmitting(false);
			premiumReportData.setLoading(false);
		}
	};

	return (
		<>
			<Button color='primary' variant='contained' onClick={handleOpen}>
				Replace
			</Button>
			<Dialog
				fullWidth
				open={open}
				onClose={handleClose}
				aria-labelledby='replace-report-title'
			>
				<DialogTitle id='replace-report-title'>Replace Report</DialogTitle>
				<DialogContent>
					<Typography>
						Are you sure you want to replace this premium report?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
						disabled={submitting}
					>
						Cancel
					</Button>
					<Button
						onClick={replaceReport}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
						disabled={submitting}
					>
						Replace
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default withPremiumReportContext(ReplaceReportModal);
